"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strIncludes = exports.dictionaryToArray = exports.pxToRem = void 0;
function pxToRem(px, base) {
    if (base === void 0) { base = 16; }
    return px / base + "rem";
}
exports.pxToRem = pxToRem;
function dictionaryToArray(dict) {
    return Object.keys(dict).map(function (key) { return dict[key]; });
}
exports.dictionaryToArray = dictionaryToArray;
function strIncludes(filter, value) {
    return value.toLowerCase().includes(filter.toLowerCase());
}
exports.strIncludes = strIncludes;
//# sourceMappingURL=base.js.map